import * as React from "react";
import Gravatar from "react-gravatar";

const defaultStyles = {
  borderRadius: "50%"
};

const Avatar = ({ style, ...otherProps }) => (
  <Gravatar style={{ ...defaultStyles, ...style }} {...otherProps} />
);

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.js